import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/store';
import routes from '@/router/routes';
import { PAGE_NOT_FOUND, PAGE_PORTAIL_CLIENT, PAGE_RECOM } from '@/router/routerConf';
import { estHashPortailClient } from '@/services/recommandation/hashPortail';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name === PAGE_NOT_FOUND) {
    next();
    return;
  }
  if (!to.query.hash) {
    next({ name: PAGE_NOT_FOUND });
    return;
  }
  if (to.query.hash !== store.state.recommandation.hash) {
    store.commit('recommandation/SET_HASH', to.query.hash);
  }
  const routeName = estHashPortailClient(to.query.hash) ? PAGE_PORTAIL_CLIENT : PAGE_RECOM;
  if (to.name !== routeName) {
    next({ name: routeName, query: to.query });
    return;
  }
  next();
});

export default router;
